module.exports = __webpack_public_path__ + "static/donate-6f1933377a5ede6932e761e57cb840d5.pdf";